export enum DataCenterPrefix {
  Unknown = '-', // This is returned for development and acceptance environments
  US = 'US',
  EU = 'EU',
  CA = 'CA'
}
